import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-disabled", "title"]
const _hoisted_2 = { class: "quiz-tile__title" }
const _hoisted_3 = { class: "quiz-tile__description" }
const _hoisted_4 = {
  key: 0,
  class: "quiz-tile__score"
}
const _hoisted_5 = { class: "dive-code" }
const _hoisted_6 = ["title"]

import { Quiz } from '@/models/Quiz';
import { progress } from '@/composables/progress';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizTileComponent',
  props: {
    quiz: {}
  },
  emits: ["setQuiz"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const setQuiz = (id: string) => {
  if (props.quiz.comingSoon) {
    return;
  }

  emit('setQuiz', id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quiz-tile", { 'quiz-tile--coming-soon': props.quiz.comingSoon }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (setQuiz(props.quiz.id))),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (setQuiz(props.quiz.id)), ["enter","space"])),
    tabIndex: "0",
    "aria-disabled": props.quiz.comingSoon,
    role: "button",
    title: props.quiz.comingSoon ? 'Demnächst verfügbar' : ''
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(props.quiz.name), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(props.quiz.description), 1)
    ]),
    (props.quiz.completed && props.quiz.score)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("code", _hoisted_5, _toDisplayString(Math.round(props.quiz.score)) + "% ", 1)
        ]))
      : _createCommentVNode("", true),
    (!props.quiz.comingSoon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "quiz-tile__progress",
          title: 'Fortschritt: ' + _unref(progress)(_ctx.quiz) + '%'
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([_unref(progress)(_ctx.quiz) === 100 ? 'quiz-tile__progress--bar--completed' : '', 'quiz-tile__progress--bar']),
            style: _normalizeStyle({ width: _unref(progress)(_ctx.quiz) + '%'})
          }, null, 6)
        ], 8, _hoisted_6))
      : _createCommentVNode("", true)
  ], 42, _hoisted_1))
}
}

})